<template>
  <div :id="`${source}_video_preview`">
    <CustomModal
      v-model:visible="modal_visible"
      :variant="variants.VARIANT2"
      :title="video?.title"
    >
      <div class="video_preview_container">
        <iframe
          v-if="isYouTubeVideo"
          :src="video_embed_url"
          :title="video?.title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          class="w-full h-full"
        ></iframe>

        <video
          v-else
          :src="video_embed_url"
          controls
          autoplay
          class="w-full h-full"
        >
          <source :src="video_embed_url" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </CustomModal>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { variants } from "@/src/constants/customComponentConstants.js";
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, default: false },
  video: { type: Object, default: null },
});

const emit = defineEmits(["update:visible"]);

const modal_visible = ref(props.visible);

watch(
  () => props.visible,
  (new_val) => {
    modal_visible.value = new_val;
  },
);

watch(
  () => modal_visible.value,
  (new_val) => {
    emit("update:visible", new_val);
  },
);

const isYouTubeVideo = computed(() => {
  return !!props.video?.id;
});

const video_embed_url = computed(() => {
  if (props.video?.id) {
    return `https://www.youtube.com/embed/${props.video.id}?autoplay=1&rel=0`;
  }
  return props.video?.url || "";
});
</script>

<style scoped>
.video_preview_container {
  width: 800px;
  height: 450px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 900px) {
  .video_preview_container {
    width: 70vw;
    height: calc(70vw * 9 / 16);
  }
}

@media (max-width: 600px) {
  .video_preview_container {
    width: 80vw;
    height: calc(80vw * 9 / 16);
  }
}
</style>
